import { t } from '@/translations/translations';

// Default fallback exchange rate
const DEFAULT_MXN_TO_USD = 17.24;

// Convert price based on language and exchange rate
const toPrice = (mxnPrice, language, exchangeRate) => {
  if (language === 'es') return mxnPrice;
  const rate = exchangeRate || DEFAULT_MXN_TO_USD;
  return Math.round((mxnPrice / rate) * 100) / 100;
};

// Get translated products based on language
export const getProducts = (language, exchangeRate) => {
  return [
    // Producto 1: Tzitzit Lana Kol Haposkim
    {
      id: 1,
      name: language === 'es' ? 'Tzitzit Lana Kol Haposkim' : 'Tzitzit Wool Kol Haposkim Measures',
      material: "lana",
      fabric: language === 'es' ? '100% Lana' : '100% Wool',
      style: "Kol Haposkim",
      price: toPrice(899.99, language, exchangeRate),
      currency: language === 'es' ? 'MXN' : 'USD',
      image: "/products/1.webp",
      description: language === 'es' 
        ? 'Tzitzit atado según todas las opiniones rabínicas (Kol Haposkim), cumpliendo con los más altos estándares halájicos.' 
        : 'Tzitzit tied according to all rabbinical opinions (Kol Haposkim), meeting the highest halachic standards.',
      kashrut: language === 'es' ? 'Certificado Mehadrin - Kol Haposkim' : 'Mehadrin Certified - Kol Haposkim',
      sizes: language === 'es' 
        ? ["Adulto S", "Adulto M", "Adulto L", "Adulto XL", "Adulto XXL"]
        : ["Adult S", "Adult M", "Adult L", "Adult XL", "Adult XXL"],
      colors: [
        { name: language === 'es' ? 'Lana Natural' : 'Natural Wool', value: '#E8DCC4', image: '/products/1.webp' }
      ],
      inStock: true,
      features: language === 'es' 
        ? ['Atado Kol Haposkim', 'Cumple todas las opiniones', 'Certificación Mehadrin', 'Máxima calidad']
        : ['Kol Haposkim tying', 'Fulfills all opinions', 'Mehadrin certification', 'Highest quality']
    },
    
    // Promoción: Pack 4x Kol Haposkim
    {
      id: 11,
      name: language === 'es' ? 'Promo 4x Tzitzit Lana Kol Haposkim' : 'Promo 4x Wool Tzitzit Kol Haposkim',
      material: "lana",
      fabric: language === 'es' ? '100% Lana' : '100% Wool',
      style: "Kol Haposkim",
      price: toPrice(2899, language, exchangeRate),
      currency: language === 'es' ? 'MXN' : 'USD',
      image: "/products/1.webp",
      isPromo: true,
      promoLabel: language === 'es' ? '4 piezas - Ahorra $700' : '4 pieces - Save $700',
      description: language === 'es' 
        ? 'Pack de 4 Tzitzit Lana Kol Haposkim a precio especial. Atados según todas las opiniones rabínicas. Precio regular: $3,600 MXN.' 
        : 'Pack of 4 Wool Tzitzit Kol Haposkim at a special price. Tied according to all rabbinical opinions. Regular price: $3,600 MXN.',
      kashrut: language === 'es' ? 'Certificado Mehadrin - Kol Haposkim' : 'Mehadrin Certified - Kol Haposkim',
      sizes: language === 'es' 
        ? ["Adulto S", "Adulto M", "Adulto L", "Adulto XL", "Adulto XXL"]
        : ["Adult S", "Adult M", "Adult L", "Adult XL", "Adult XXL"],
      colors: [
        { name: language === 'es' ? 'Lana Natural' : 'Natural Wool', value: '#E8DCC4', image: '/products/1.webp' }
      ],
      inStock: true,
      features: language === 'es' 
        ? ['4 Tzitzit Kol Haposkim', 'Ahorro de $700 MXN', 'Certificación Mehadrin', 'Máxima calidad']
        : ['4 Kol Haposkim Tzitzit', 'Save $700 MXN', 'Mehadrin certification', 'Highest quality']
    },
    
    // Producto 5: Tzitzit Algodón Tank Top
    {
      id: 5,
      name: language === 'es' ? 'Tzitzit Algodón Tank Top' : 'Tzitzit Cotton Tank Top',
      material: "algodon",
      fabric: language === 'es' ? '100% Algodón' : '100% Cotton',
      style: "Tank Top",
      price: toPrice(249.99, language, exchangeRate),
      priceMax: toPrice(389.99, language, exchangeRate),
      currency: language === 'es' ? 'MXN' : 'USD',
      hasCottonType: true,
      pricingRules: {
        kidsThreads: ['mechona_delgado', 'sin_hilos'],
        adultThreads: ['avodat_yad_grueso', 'avodat_yad_delgado', 'mechona_delgado', 'sin_hilos'],
        kidsPrice: toPrice(249.99, language, exchangeRate),
        kidsPrices: {
          'sin_hilos': toPrice(199.99, language, exchangeRate)
        },
        adultPrices: {
          'avodat_yad_grueso': toPrice(389.99, language, exchangeRate),
          'avodat_yad_delgado': toPrice(389.99, language, exchangeRate),
          'mechona_delgado': toPrice(349.99, language, exchangeRate),
          'sin_hilos': toPrice(299.99, language, exchangeRate)
        }
      },
      image: "/products/tank-white.webp",
      description: language === 'es' 
        ? 'Tzitzit de algodón suave y transpirable en estilo tank top, ideal para climas cálidos.' 
        : 'Soft and breathable cotton Tzitzit in tank top style, ideal for warm climates.',
      kashrut: language === 'es' ? 'Certificado Kosher - Badatz' : 'Kosher Certified - Badatz',
      sizes: language === 'es' 
        ? ["Niño 1-2", "Niño 3-4", "Niño 5-6", "Niño 7-8", "Niño 9-10", "Niño 11-12", "XL Boys", "Adulto S", "Adulto M", "Adulto L", "Adulto XL", "Adulto XXL"]
        : ["Boys 1-2", "Boys 3-4", "Boys 5-6", "Boys 7-8", "Boys 9-10", "Boys 11-12", "XL Boys", "Adult S", "Adult M", "Adult L", "Adult XL", "Adult XXL"],
      colors: [
        { name: language === 'es' ? 'Blanco' : 'White', value: '#FFFFFF', image: '/products/tank-white.webp' }
      ],
      inStock: true,
      features: language === 'es' 
        ? ['Algodón 1° calidad', 'Diseño Tank Top', 'Transpirable', 'Fácil cuidado']
        : ['1st quality cotton', 'Tank Top design', 'Breathable', 'Easy care']
    },
    
    // Producto 2: Tzitzit Lana Tank Top
    {
      id: 2,
      name: language === 'es' ? 'Tzitzit Lana Tank Top' : 'Tzitzit Wool Tank Top',
      material: "lana",
      fabric: language === 'es' ? '100% Lana' : '100% Wool',
      style: "Tank Top",
      price: toPrice(899.99, language, exchangeRate),
      currency: language === 'es' ? 'MXN' : 'USD',
      image: "/products/2.webp",
      description: language === 'es' 
        ? 'Tzitzit de lana 100% pura en estilo tank top, cómodo y tradicional.' 
        : '100% pure wool Tzitzit in tank top style, comfortable and traditional.',
      kashrut: language === 'es' ? 'Certificado Mehadrin - Supervisión Rabínica' : 'Mehadrin Certified - Rabbinical Supervision',
      sizes: language === 'es' 
        ? ["Adulto S", "Adulto M", "Adulto L", "Adulto XL", "Adulto XXL"]
        : ["Adult S", "Adult M", "Adult L", "Adult XL", "Adult XXL"],
      colors: [
        { name: language === 'es' ? 'Lana Natural' : 'Natural Wool', value: '#E8DCC4', image: '/products/wool-tank-natural.webp' },
        { name: language === 'es' ? 'Blanco Teñido' : 'Dyed White', value: '#FFFFFF', image: '/products/dyed-white.webp' },
        { name: language === 'es' ? 'Tzahal Edition Verde' : 'Tzahal Green Edition', value: '#4A5D23', image: '/products/wool-tank-tzahal.webp' }
      ],
      inStock: false,
      features: language === 'es' 
        ? ['Lana 100% natural', 'Diseño Tank Top', 'Certificación Mehadrin', 'Máximo confort']
        : ['100% natural wool', 'Tank Top design', 'Mehadrin certification', 'Maximum comfort']
    },
    
    // Producto 3: Tzitzit Lana T-Shirt Botones Invisibles
    {
      id: 3,
      name: language === 'es' ? 'Tzitzit Lana T-Shirt Botones Invisibles' : 'Tzitzit Wool T-Shirt Invisible Buttons',
      material: "lana",
      fabric: language === 'es' ? '100% Lana' : '100% Wool',
      style: "T-Shirt",
      price: toPrice(999.99, language, exchangeRate),
      kidsDiscount: toPrice(15, language, exchangeRate),
      currency: language === 'es' ? 'MXN' : 'USD',
      image: "/products/tshirt-wool.webp",
      description: language === 'es' 
        ? 'Tzitzit de lana premium en estilo T-Shirt con botones invisibles, combina tradición con estilo moderno.' 
        : 'Premium wool Tzitzit in T-Shirt style with invisible buttons, combines tradition with modern style.',
      kashrut: language === 'es' ? 'Certificado Mehadrin' : 'Mehadrin Certified',
      sizes: language === 'es' 
        ? ["Niño S", "Niño M", "Niño L", "Niño XL", "Adulto S", "Adulto M", "Adulto L", "Adulto XL", "Adulto XXL"]
        : ["Boys S", "Boys M", "Boys L", "Boys XL", "Adult S", "Adult M", "Adult L", "Adult XL", "Adult XXL"],
      colors: [
        { name: language === 'es' ? 'Blanco' : 'White', value: '#FFFFFF', image: '/products/tshirt-white.webp', outOfStock: true },
        { name: language === 'es' ? 'Azul Cielo' : 'Sky Blue', value: '#87CEEB', image: '/products/tshirt-lightblue.webp', outOfStock: true },
        { name: language === 'es' ? 'Tzahal Edition Verde' : 'Tzahal Green Edition', value: '#4A5D23', image: '/products/wool-tshirt-tzahal.webp' },
        { name: language === 'es' ? 'Negro' : 'Black', value: '#1a1a1a', image: '/products/tshirt-black.webp' }
      ],
      inStock: true,
      features: language === 'es' 
        ? ['Lana 100% natural', 'Botones invisibles', 'Certificación Mehadrin', 'Elegante y cómodo']
        : ['100% natural wool', 'Invisible buttons', 'Mehadrin certification', 'Elegant and comfortable']
    },
    
    // Producto 4: Talit Gadol 100% Lana
    {
      id: 4,
      name: language === 'es' ? 'Talit Gadol 100% Lana - Antideslizante' : 'Talit Gadol 100% Wool - Non Slip',
      material: "lana",
      fabric: language === 'es' ? '100% Lana' : '100% Wool',
      style: "Talit Gadol",
      price: toPrice(2099.99, language, exchangeRate),
      currency: language === 'es' ? 'MXN' : 'USD',
      image: "/products/talit-gadol.webp",
      description: language === 'es' 
        ? 'Talit Gadol de lana premium con sistema antideslizante, ideal para la oración.' 
        : 'Premium wool Talit Gadol with non-slip system, ideal for prayer.',
      kashrut: language === 'es' ? 'Certificado Mehadrin - Supervisión Rabínica' : 'Mehadrin Certified - Rabbinical Supervision',
      sizes: language === 'es' 
        ? ["Standard", "Grande", "Extra Grande"]
        : ["Standard", "Large", "Extra Large"],
      colors: [
        { name: language === 'es' ? 'Blanco' : 'White', value: '#FFFFFF', image: '/products/talit-gadol.webp' }
      ],
      inStock: false,
      features: language === 'es' 
        ? ['Lana 100% pura', 'Sistema antideslizante', 'Certificación Mehadrin', 'Tradición y elegancia']
        : ['100% pure wool', 'Non-slip system', 'Mehadrin certification', 'Tradition and elegance']
    },
    
    // Producto 6: Tank Top Algodón (sin tzitzit)
    {
      id: 6,
      name: language === 'es' ? 'Pack 3x Tank Top Algodón' : '3-Pack Cotton Tank Top',
      material: "algodon",
      fabric: language === 'es' ? '100% Algodón' : '100% Cotton',
      style: "Tank Top",
      price: toPrice(400, language, exchangeRate),
      noTzitzit: true,
      hasCottonType: true,
      currency: language === 'es' ? 'MXN' : 'USD',
      image: "/products/3pack-tank.webp",
      description: language === 'es' 
        ? 'Tank top de algodón sencilla, sin tzitzit ni hilos. Perfecta como prenda interior o de uso diario.' 
        : 'Simple cotton tank top, no tzitzit or threads. Perfect as underwear or for daily use.',
      kashrut: language === 'es' ? 'N/A - Prenda sin tzitzit' : 'N/A - Garment without tzitzit',
      sizes: language === 'es' 
        ? ["Niño 1-2", "Niño 3-4", "Niño 5-6", "Niño 7-8", "Niño 9-10", "Niño 11-12", "XL Boys", "Adulto S", "Adulto M", "Adulto L", "Adulto XL", "Adulto XXL"]
        : ["Boys 1-2", "Boys 3-4", "Boys 5-6", "Boys 7-8", "Boys 9-10", "Boys 11-12", "XL Boys", "Adult S", "Adult M", "Adult L", "Adult XL", "Adult XXL"],
      colors: [
        { name: language === 'es' ? 'Blanco' : 'White', value: '#FFFFFF', image: '/products/3pack-tank.webp' }
      ],
      inStock: true,
      features: language === 'es' 
        ? ['Algodón suave', 'Sin tzitzit', 'Prenda sencilla', 'Uso diario']
        : ['Soft cotton', 'No tzitzit', 'Simple garment', 'Daily use']
    },
    
    // Producto 7: Tzitzit Bambú Tank Top
    {
      id: 7,
      name: language === 'es' ? 'Tzitzit Bambú Tank Top' : 'Tzitzit Bamboo Tank Top',
      material: "bambu",
      fabric: language === 'es' ? '95% Viscosa de Bambú 5% Spandex' : '95% Bamboo Viscose 5% Spandex',
      style: "Tank Top",
      price: toPrice(399.99, language, exchangeRate),
      currency: language === 'es' ? 'MXN' : 'USD',
      image: "/products/tank-white.webp",
      description: language === 'es' 
        ? 'Tzitzit de fibra de bambú en estilo tank top, ultra suave y ecológico.' 
        : 'Bamboo fiber Tzitzit in tank top style, ultra soft and eco-friendly.',
      kashrut: language === 'es' ? 'Certificado Kosher' : 'Kosher Certified',
      sizes: language === 'es' 
        ? ["Niño 4", "Niño 6", "Niño 8", "Niño 10", "Niño 12", "Niño 14", "Adulto S", "Adulto M", "Adulto L", "Adulto XL", "Adulto XXL"]
        : ["Boys 4", "Boys 6", "Boys 8", "Boys 10", "Boys 12", "Boys 14", "Adult S", "Adult M", "Adult L", "Adult XL", "Adult XXL"],
      outOfStockSizes: language === 'es'
        ? ["Adulto S", "Adulto M", "Adulto L", "Adulto XL", "Adulto XXL"]
        : ["Adult S", "Adult M", "Adult L", "Adult XL", "Adult XXL"],
      colors: [
        { name: language === 'es' ? 'Blanco' : 'White', value: '#FFFFFF', image: '/products/tank-white.webp' }
      ],
      inStock: true,
      features: language === 'es' 
        ? ['Fibra de bambú', 'Diseño Tank Top', 'Eco-friendly', 'Ultra suave']
        : ['Bamboo fiber', 'Tank Top design', 'Eco-friendly', 'Ultra soft']
    },
    
    // Producto 8: Tzitzit Bambú T-Shirt Botones Invisibles
    {
      id: 8,
      name: language === 'es' ? 'Tzitzit Bambú T-Shirt Botones Invisibles' : 'Tzitzit Bamboo T-Shirt Invisible Buttons',
      material: "bambu",
      fabric: language === 'es' ? '95% Viscosa de Bambú 5% Spandex' : '95% Bamboo Viscose 5% Spandex',
      style: "T-Shirt",
      price: toPrice(499.99, language, exchangeRate),
      kidsDiscount: toPrice(15, language, exchangeRate),
      currency: language === 'es' ? 'MXN' : 'USD',
      image: "/products/tshirt-bamboo.webp",
      description: language === 'es' 
        ? 'Tzitzit ecológico de fibra de bambú en estilo T-Shirt con botones invisibles.' 
        : 'Eco-friendly bamboo fiber Tzitzit in T-Shirt style with invisible buttons.',
      kashrut: language === 'es' ? 'Certificado Kosher' : 'Kosher Certified',
      sizes: language === 'es' 
        ? ["Niño 4", "Niño 6", "Niño 8", "Niño 10", "Niño 12", "Niño 14", "Adulto S", "Adulto M", "Adulto L", "Adulto XL", "Adulto XXL"]
        : ["Boys 4", "Boys 6", "Boys 8", "Boys 10", "Boys 12", "Boys 14", "Adult S", "Adult M", "Adult L", "Adult XL", "Adult XXL"],
      colors: [
        { name: language === 'es' ? 'Blanco' : 'White', value: '#FFFFFF', image: '/products/tshirt-white.webp' },
        { name: language === 'es' ? 'Negro' : 'Black', value: '#1a1a1a', image: '/products/tshirt-black.webp' },
        { name: language === 'es' ? 'Gris' : 'Gray', value: '#5A6367', image: '/products/tshirt-gray.webp', outOfStock: true }
      ],
      inStock: false,
      features: language === 'es' 
        ? ['Fibra de bambú', 'Botones invisibles', 'Antibacteriano natural', 'Eco-friendly']
        : ['Bamboo fiber', 'Invisible buttons', 'Natural antibacterial', 'Eco-friendly']
    },
    
    // Producto 9: Tzitzit Dry-Fit T-Shirt Botones Invisibles
    {
      id: 9,
      name: language === 'es' ? 'Tzitzit Dry-Fit T-Shirt Botones Invisibles' : 'Tzitzit Dry-Fit T-Shirt Invisible Buttons',
      material: "poliester",
      fabric: language === 'es' ? '95% Poliéster 5% Spandex' : '95% Polyester 5% Spandex',
      style: "T-Shirt",
      price: toPrice(399.99, language, exchangeRate),
      kidsDiscount: toPrice(15, language, exchangeRate),
      currency: language === 'es' ? 'MXN' : 'USD',
      image: "/products/tshirt-dryfit.webp",
      description: language === 'es' 
        ? 'Tzitzit dry-fit de alta tecnología con botones invisibles, perfecto para deportes.' 
        : 'High-tech dry-fit Tzitzit with invisible buttons, perfect for sports.',
      kashrut: language === 'es' ? 'Certificado Kosher' : 'Kosher Certified',
      sizes: language === 'es' 
        ? ["Niño 4", "Niño 6", "Niño 8", "Niño 10", "Niño 12", "Niño 14", "Adulto S", "Adulto M", "Adulto L", "Adulto XL", "Adulto XXL"]
        : ["Boys 4", "Boys 6", "Boys 8", "Boys 10", "Boys 12", "Boys 14", "Adult S", "Adult M", "Adult L", "Adult XL", "Adult XXL"],
      colors: [
        { name: language === 'es' ? 'Azul' : 'Blue', value: '#5B9BD5', image: '/products/tshirt-blue.webp' },
        { name: language === 'es' ? 'Blanco' : 'White', value: '#FFFFFF', image: '/products/tshirt-white.webp' },
        { name: language === 'es' ? 'Negro' : 'Black', value: '#1a1a1a', image: '/products/tshirt-black.webp' }
      ],
      inStock: false,
      features: language === 'es' 
        ? ['Tecnología Dry-Fit', 'Botones invisibles', 'Secado rápido', 'Ideal para deportes']
        : ['Dry-Fit technology', 'Invisible buttons', 'Quick drying', 'Ideal for sports']
    },
    
    // Producto 10: Pack 3x Tank Top Bambú
    {
      id: 10,
      name: language === 'es' ? 'Pack 3x Tank Top Bambú' : '3-Pack Bamboo Tank Top',
      material: "bambu",
      fabric: language === 'es' ? '95% Viscosa de Bambú 5% Spandex' : '95% Bamboo Viscose 5% Spandex',
      style: "Tank Top",
      price: toPrice(500, language, exchangeRate),
      noTzitzit: true,
      currency: language === 'es' ? 'MXN' : 'USD',
      image: "/products/3pack-tank.webp",
      description: language === 'es' 
        ? 'Tank top de bambú sencilla, sin tzitzit ni hilos. Ultra suave y ecológica, perfecta como prenda interior o de uso diario.' 
        : 'Simple bamboo tank top, no tzitzit or threads. Ultra soft and eco-friendly, perfect as underwear or for daily use.',
      kashrut: language === 'es' ? 'N/A - Prenda sin tzitzit' : 'N/A - Garment without tzitzit',
      sizes: language === 'es' 
        ? ["Niño 1-2", "Niño 3-4", "Niño 5-6", "Niño 7-8", "Niño 9-10", "Niño 11-12", "XL Boys", "Adulto S", "Adulto M", "Adulto L", "Adulto XL", "Adulto XXL"]
        : ["Boys 1-2", "Boys 3-4", "Boys 5-6", "Boys 7-8", "Boys 9-10", "Boys 11-12", "XL Boys", "Adult S", "Adult M", "Adult L", "Adult XL", "Adult XXL"],
      colors: [
        { name: language === 'es' ? 'Blanco' : 'White', value: '#FFFFFF', image: '/products/3pack-tank.webp' }
      ],
      inStock: false,
      features: language === 'es' 
        ? ['Fibra de bambú', 'Sin tzitzit', 'Ultra suave', 'Eco-friendly']
        : ['Bamboo fiber', 'No tzitzit', 'Ultra soft', 'Eco-friendly']
    }
  ];
};

export const testimonials = [
  {
    id: 1,
    name: "David Cohen",
    location: "Jerusalem, Israel",
    rating: 5,
    comment: {
      es: "La calidad de los tzitziot de lana es excepcional. Se nota el cuidado en cada detalle y la certificación kashrut es impecable.",
      en: "The quality of the wool tzitziot is exceptional. The care in every detail is noticeable and the kashrut certification is impeccable.",
      he: "איכות ציציות הצמר יוצאת דופן. ניכרת תשומת הלב לכל פרט והכשרות ללא דופי."
    },
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=David"
  },
  {
    id: 2,
    name: "Rafael Levi",
    location: "Miami, USA",
    rating: 5,
    comment: {
      es: "Los tzitziot de bambú son increíblemente suaves. Perfectos para el clima de Florida. Altamente recomendado.",
      en: "The bamboo tzitziot are incredibly soft. Perfect for Florida weather. Highly recommended.",
      he: "ציציות הבמבוק רכות להפליא. מושלמות למזג האוויר של פלורידה. מומלץ בחום."
    },
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Rafael"
  },
  {
    id: 3,
    name: "Moshe Goldstein",
    location: "Buenos Aires, Argentina",
    rating: 5,
    comment: {
      es: "Excelente servicio y productos de primera calidad. Los tzitziot de algodón son mis favoritos.",
      en: "Excellent service and top quality products. The cotton tzitziot are my favorites.",
      he: "שירות מצוין ומוצרים באיכות מעולה. ציציות הכותנה הן האהובות עליי."
    },
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Moshe"
  },
  {
    id: 4,
    name: "Yosef Klein",
    location: "New York, USA",
    rating: 5,
    comment: {
      es: "Como deportista, los tzitziot de poliéster son perfectos. Resistentes y cómodos para cualquier actividad.",
      en: "As an athlete, the polyester tzitziot are perfect. Resistant and comfortable for any activity.",
      he: "כספורטאי, ציציות הפוליאסטר מושלמות. עמידות ונוחות לכל פעילות."
    },
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Yosef"
  }
];

export const sizeGuide = {
  title: { es: "Guía de Tallas", en: "Size Guide", he: "מדריך מידות" },
  description: { es: "Encuentra la talla perfecta para tus tzitziot", en: "Find the perfect size for your tzitziot", he: "מצאו את המידה המושלמת לציציות שלכם" },
  adult: {
    title: { es: "Adulto - Tank Top", en: "Adult - Tank Top", he: "מבוגר - גופייה" },
    sizes: [
      { size: "S", largo: "63 cm", ancho: "50 cm" },
      { size: "M", largo: "66 cm", ancho: "52 cm" },
      { size: "L", largo: "69 cm", ancho: "54 cm" },
      { size: "XL", largo: "72 cm", ancho: "57 cm" },
      { size: "XXL", largo: "77 cm", ancho: "59 cm" }
    ]
  },
  kids: {
    title: { es: "Niño", en: "Boys", he: "ילד" },
    sizes: [
      { size: "1-2", age: { es: "1-2 años", en: "1-2 years", he: "גיל 1-2" }, chest: "48-52 cm", length: "35 cm" },
      { size: "3-4", age: { es: "3-4 años", en: "3-4 years", he: "גיל 3-4" }, chest: "53-56 cm", length: "40 cm" },
      { size: "5-6", age: { es: "5-6 años", en: "5-6 years", he: "גיל 5-6" }, chest: "57-61 cm", length: "45 cm" },
      { size: "7-8", age: { es: "7-8 años", en: "7-8 years", he: "גיל 7-8" }, chest: "62-67 cm", length: "50 cm" },
      { size: "9-10", age: { es: "9-10 años", en: "9-10 years", he: "גיל 9-10" }, chest: "68-73 cm", length: "55 cm" },
      { size: "11-12", age: { es: "11-12 años", en: "11-12 years", he: "גיל 11-12" }, chest: "74-79 cm", length: "58 cm" },
      { size: "XL Boys", age: { es: "13-14 años", en: "13-14 years", he: "גיל 13-14" }, chest: "80-85 cm", length: "60 cm" }
    ]
  },
  kidsLettered: {
    title: { es: "Niño (T-Shirt)", en: "Boys (T-Shirt)", he: "ילד (חולצה)" },
    sizes: [
      { size: "S", age: { es: "4-6 años", en: "4-6 years", he: "גיל 4-6" }, chest: "53-61 cm", length: "40-45 cm" },
      { size: "M", age: { es: "7-9 años", en: "7-9 years", he: "גיל 7-9" }, chest: "62-70 cm", length: "46-50 cm" },
      { size: "L", age: { es: "10-12 años", en: "10-12 years", he: "גיל 10-12" }, chest: "71-79 cm", length: "51-56 cm" },
      { size: "XL", age: { es: "13-14 años", en: "13-14 years", he: "גיל 13-14" }, chest: "80-85 cm", length: "57-60 cm" }
    ]
  }
};

export const kashrutInfo = {
  title: { es: "Información de Kashrut", en: "Kashrut Information" },
  description: { 
    es: "Todos nuestros productos cumplen con los más altos estándares de kashrut",
    en: "All our products meet the highest kashrut standards"
  },
  certifications: [
    {
      name: "Mehadrin",
      description: {
        es: "Supervisión rabínica estricta durante todo el proceso de fabricación",
        en: "Strict rabbinical supervision throughout the entire manufacturing process"
      },
      products: { es: ["Lana Premium"], en: ["Premium Wool"] }
    },
    {
      name: "Badatz",
      description: {
        es: "Certificación del Tribunal Rabínico de Justicia",
        en: "Certification from the Rabbinical Court of Justice"
      },
      products: { es: ["Algodón"], en: ["Cotton"] }
    },
    {
      name: { es: "Kosher Certificado", en: "Certified Kosher" },
      description: {
        es: "Certificación kosher estándar garantizada",
        en: "Guaranteed standard kosher certification"
      },
      products: { es: ["Bambú Eco", "Poliéster Deportivo"], en: ["Bamboo Eco", "Sports Polyester"] }
    }
  ],
  requirements: {
    es: [
      "Todos los hilos son hilados por personal capacitado",
      "Proceso de manufactura supervisado rabínicamente",
      "Materiales verificados y aprobados",
      "Cumplimiento estricto de Halacha (ley judía)",
      "Documentación completa disponible"
    ],
    en: [
      "All threads are spun by trained personnel",
      "Rabbinically supervised manufacturing process",
      "Verified and approved materials",
      "Strict compliance with Halacha (Jewish law)",
      "Complete documentation available"
    ]
  }
};

// Cart management (localStorage)
export const cartUtils = {
  getCart: () => {
    const cart = localStorage.getItem('mitzvafitCart');
    return cart ? JSON.parse(cart) : [];
  },
  
  saveCart: (cart) => {
    localStorage.setItem('mitzvafitCart', JSON.stringify(cart));
  },
  
  addToCart: (product, size, quantity = 1) => {
    const cart = cartUtils.getCart();
    const existingItem = cart.find(item => 
      item.id === product.id && 
      item.size === size &&
      item.selectedTradition === product.selectedTradition &&
      item.selectedHilos === product.selectedHilos &&
      item.selectedCottonType === product.selectedCottonType &&
      item.selectedColor?.value === product.selectedColor?.value &&
      JSON.stringify(item.customSelections || {}) === JSON.stringify(product.customSelections || {})
    );
    
    if (existingItem) {
      existingItem.quantity += quantity;
    } else {
      cart.push({
        ...product,
        size,
        quantity
      });
    }
    
    cartUtils.saveCart(cart);
    return cart;
  },
  
  removeFromCart: (productId, size, options = {}) => {
    let cart = cartUtils.getCart();
    cart = cart.filter(item => !(
      item.id === productId && 
      item.size === size &&
      item.selectedTradition === options.selectedTradition &&
      item.selectedHilos === options.selectedHilos &&
      item.selectedCottonType === options.selectedCottonType &&
      item.selectedColor?.value === options.selectedColorValue
    ));
    cartUtils.saveCart(cart);
    return cart;
  },
  
  updateQuantity: (productId, size, quantity, options = {}) => {
    const cart = cartUtils.getCart();
    const item = cart.find(item => 
      item.id === productId && 
      item.size === size &&
      item.selectedTradition === options.selectedTradition &&
      item.selectedHilos === options.selectedHilos &&
      item.selectedCottonType === options.selectedCottonType &&
      item.selectedColor?.value === options.selectedColorValue
    );
    
    if (item) {
      item.quantity = quantity;
    }
    
    cartUtils.saveCart(cart);
    return cart;
  },
  
  clearCart: () => {
    localStorage.removeItem('mitzvafitCart');
    return [];
  },
  
  getTotal: () => {
    const cart = cartUtils.getCart();
    return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  },
  
  getItemCount: () => {
    const cart = cartUtils.getCart();
    return cart.reduce((count, item) => count + item.quantity, 0);
  }
};
